export const services = [
    { duration: 15, id: 55001, name: 'Henkilöauto', price: 39, icon: 'car'},
    { duration: 15, id: 55002, name: 'Pakettiauto', price: 49, icon: 'van'},
    { duration: 15, id: 55004, name: 'Asuntoauto, paripyöräauto', price: 59, icon: 'camper'},
    { duration: 15, id: 103872, name: 'Maastoauto, SUV', price: 49, icon: 'suv'},
    { duration: 15, id: 103870, name: 'Sähköauto', price: 49, icon: 'electric'},
];

export const shops = [
    { id: 1, name: 'Vanha Hämeentie 134', city: 'Turku'},
    { id: 2, name: 'Rieskalähteentie 80', city: 'Turku'},
    { id: 7, name: 'Länsi-Avantintie 7', city: 'Lieto'},
    { id: 3, name: 'Automestarinkatu 5', city: 'Kaarina'},
    { id: 5, name: 'Meriniitynkatu 15', city: 'Salo'},
];


/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/tire-change/constants.js
 **/